import apiFetch from '../apiFetch'

export default function (documentsSelected, documentHistoricalsSelected, token) {
  return apiFetch({ endPoint: `Document/${documentsSelected + '-' + documentHistoricalsSelected}/DownloadList`, parseBlobAndAssign: true, method: 'GET', body: null, token: token })
}
